import { render, staticRenderFns } from "./setItemsForTrack.vue?vue&type=template&id=4b2891b4"
import script from "./setItemsForTrack.js?vue&type=script&lang=js&external"
export * from "./setItemsForTrack.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports